<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
  <wiz-hgroup width="100%" height="30px" verticalAlign="center" padding="3px" gap="2">
    <wiz-label #lbTitle width="100%" class="smallTitleLabel" [wizLabel]="'$.pivot.delete.line.$'"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <wiz-hgroup width="100%" height="100%">
    <wiz-list
      #fieldList
      width="100%"
      height="100%"
      [wizDataProvider]="mainDS"
      [wizLabelField]="'label'"
      [wizItemRenderer]="fieldRenderer"
    >
    </wiz-list>
  </wiz-hgroup>

  <wiz-hgroup width="100%" padding="5px" horizontalAlign="end">
    <wiz-button
      [wizLabel]="'$.common.confirm.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="doDelete()"
      [iconPlacement]="'right'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
